import * as React from 'react'

import { cn } from '@bnsn/ui/lib/utils'

type TextareaProps = React.ComponentProps<'textarea'> & {
  autoResize?: boolean
}

const useAutoResize = (onInput?: React.FormEventHandler<HTMLTextAreaElement>) => {
  const callback: React.FormEventHandler<HTMLTextAreaElement> = React.useCallback(
    (event) => {
      const target = event.currentTarget

      target.style.height = ''
      target.style.height = target.scrollHeight + 'px'

      if (onInput) {
        onInput(event)
      }
    },
    [onInput],
  )

  return callback
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, autoResize, ...props }, ref) => {
  const onInput = useAutoResize(props.onInput)

  return (
    <textarea
      className={cn(
        'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className,
      )}
      ref={ref}
      {...props}
      onInput={autoResize ? onInput : props.onInput}
    />
  )
})
Textarea.displayName = 'Textarea'

export { Textarea }
